import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IResponseElement, IResponseMessage } from '../models';
import { DeviceInfoService } from '@shared';

export class HttpBase<DataModel, FilterModel, SelectModel> {
  private deviceInfoService = inject(DeviceInfoService);
  readonly http: HttpClient = inject(HttpClient);
  readonly baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  search(context: FilterModel): Observable<IResponseElement<DataModel>> {
    return this.http.post<IResponseElement<DataModel>>(`${this.baseUrl}/search`, context);
  }

  delete(id: number | string): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(`${this.baseUrl}/delete/${id}`);
  }

  find(context: FilterModel): Observable<IResponseElement<DataModel>> {
    return this.http.post<IResponseElement<DataModel>>(`${this.baseUrl}/find`, context);
  }

  get(id?: number | string): Observable<DataModel> {
    return this.http.get<DataModel>(`${this.baseUrl}/get${id ? '/' + id : ''}`);
  }

  getById(id?: number | string): Observable<DataModel> {
    return this.http.get<DataModel>(`${this.baseUrl}/getById${id ? '/' + id : ''}`);
  }

  init(id?: number | string): Observable<SelectModel> {
    return this.http.get<SelectModel>(`${this.baseUrl}/init${id ? '/' + id : ''}`);
  }

  initForm(id?: number | string): Observable<DataModel> {
    return this.http.get<DataModel>(`${this.baseUrl}/initForm${id ? '/' + id : ''}`);
  }

  saveOrUpdate(context: Partial<DataModel>): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(`${this.baseUrl}/saveOrUpdate`, context);
  }

  saveOrUpdateWithInfo(context: Partial<DataModel>): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(`${this.baseUrl}/saveOrUpdate`, {
      ...context,
      ...this.deviceInfoService.deviceInfo(),
    })
  }

  saveOrUpdatePut(context: Partial<DataModel>): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(`${this.baseUrl}/saveOrUpdate`, context);
  }

  saveOrUpdateWithFile(context: Partial<DataModel>, file: File | null): Observable<IResponseMessage> {
    const formData = new FormData();
    formData.append('request', JSON.stringify(context));

    if (file) {
      formData.append('file', file);
    }

    return this.http.post<IResponseMessage>(`${this.baseUrl}/saveOrUpdate`, formData);
  }
}
